export const FILTER_BY_OPTIONS = [
    {
        text: 'All',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: '',
        key: 0
    },{
        text: 'In Library',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'isInLibrary',
        key: 1
    },{
        text: 'Videos',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'video%2f*',
        key: 2
    },{
        text: 'Images',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'image%2f*',
        key: 3
    },{
        text: 'Hotspots',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'hotspot',
        key: 4
    },{
        text: 'Documents',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'html',
        key: 5
    },{
        text: 'Web Links',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'web',
        key: 6
    },{
        text: 'Assessments',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'assessments',
        key: 7
    },{
        text: 'Checklists',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'checklist',
        key: 8
    },{
        text: 'E-Learning',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'elearning',
        key: 9
    },{
        text: 'Surveys',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'survey',
        key: 10
    },{
        text: 'Created by Me',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'creator',
        key: 11
    }
];

export const SORT_BY_OPTIONS = [
    {
        text: 'Recently Edited',
        sortBy: 'modified',
        sortDirection: true,
        key: 0
    },{
        text: 'Name (a-z)',
        sortBy: 'name',
        sortDirection: false,
        key: 1
    },{
        text: 'Name (z-a)',
        sortBy: 'name',
        sortDirection: true,
        key: 2
    }
];



// WEBPACK FOOTER //
// ./src/containers/ContentPage/constants.js